import restful from '@/utils/restful';
import * as names from '@/store/names';
import * as get from '@/store/store';

// Ámbitos de realización: como las Capacidades, pero cada perfil de egreso tiene su propio listado.
const state = {
    realization_scopes: [],
    realization_scopes_url: '/mesh/egress-profile-realization-scope'
}

const getters = {
    [names.REALIZATION_SCOPES]: state => {
        if (!get.store.state.user) return [];
        return state.realization_scopes
            .filter((x) => x.school == get.store.state.user.school)
            .sort((a, b) => a.order - b.order || a.id - b.id);
    },
}
const mutations = {
    [names.MUTATE_REALIZATION_SCOPES]: (state, realization_scopes) => {
        realization_scopes.forEach(element => {
            let index = state.realization_scopes.findIndex(x => x.id == element.id);
            if (index != -1) state.realization_scopes.splice(index, 1, element);
            else state.realization_scopes.push(element);
        });
    },
    [names.MUTATE_REALIZATION_SCOPE]: (state, realization_scope) => {
        let index = state.realization_scopes.findIndex(x => x.id == realization_scope.id);
        if (index != -1) state.realization_scopes.splice(index, 1, realization_scope);
        else state.realization_scopes.push(realization_scope);
    },
    [names.MUTATE_DELETE_REALIZATION_SCOPE]: (state, realization_scope_id) => {
        let index = state.realization_scopes.findIndex(x => x.id == realization_scope_id);
        if (index != -1) state.realization_scopes.splice(index, 1);
    },
}
const actions = {
    [names.FETCH_REALIZATION_SCOPES]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve) => {
            let partial_url = '';
            if (payload && payload.egress_profile_id) partial_url = '?egress_profile__id=' + payload.egress_profile_id;
            restful.GetAll(`${state.realization_scopes_url}/${partial_url}`)
                .then(response => {
                    commit(names.MUTATE_REALIZATION_SCOPES, response);
                    resolve(response);
                });
        });
    },
    [names.POST_REALIZATION_SCOPE]: ({
        commit,
        state
    }, realization_scope) => {
        // Rechaza si falla, para que el formulario vuelva a habilitar el botón Guardar
        return new Promise((resolve, reject) => {
            restful.Post(`${state.realization_scopes_url}/`, realization_scope)
                .then(response => {
                    commit(names.MUTATE_REALIZATION_SCOPE, response);
                    resolve(response);
                })
                .catch(reject);
        });
    },
    [names.PATCH_REALIZATION_SCOPE]: ({
        commit,
        state
    }, payload) => {
        return new Promise((resolve, reject) => {
            restful.Patch(`${state.realization_scopes_url}/${payload.realization_scope_id}/`, payload.item)
                .then(response => {
                    commit(names.MUTATE_REALIZATION_SCOPE, response);
                    resolve(response);
                })
                .catch(reject);
        });
    },
    [names.DELETE_REALIZATION_SCOPE]: ({
        commit,
        state
    }, realization_scope_id) => {
        return new Promise((resolve) => {
            restful.Delete(`${state.realization_scopes_url}/${realization_scope_id}/`)
                .then(response => {
                    commit("MUTATE_EGRESS_PROFILE_MATTER_BY_DELETE_REALIZATION_SCOPE", realization_scope_id);
                    commit("MUTATE_PROFILE_COMPETENCE_BY_DELETE_REALIZATION_SCOPE", realization_scope_id);
                    commit(names.MUTATE_DELETE_REALIZATION_SCOPE, realization_scope_id);
                    resolve(response);
                });
        });
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
